let activeToken: string | null = null;

export function setActiveBorrowerSession(token: string | null) {
  activeToken = token;
}

export function currentBorrowerSession(): string | null {
  return activeToken;
}
